import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Hamburger } from './Hamburger';
export var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleScroll", function (event) {
      var scrollAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var transparent = _this.state.transparent;
      var atTop = (scrollAmount || window.pageYOffset || document.documentElement.scrollTop) <= 5;

      if (transparent !== atTop) {
        _this.setState({
          transparent: atTop
        });
      }
    });

    _this.state = {
      transparent: props.isTransparentWhenAtScrollTop
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isTransparentWhenAtScrollTop) {
        this.installScrollHandler();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var isTransparentWhenAtScrollTop = this.props.isTransparentWhenAtScrollTop;

      if (isTransparentWhenAtScrollTop) {
        this.installScrollHandler();
      } else {
        this.uninstallScrollHandler();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.uninstallScrollHandler();
    }
  }, {
    key: "installScrollHandler",
    value: function installScrollHandler() {
      if (!this.scrollHandler) {
        this.scrollHandler = this.handleScroll;

        if (__CLIENT__) {
          window.addEventListener('scroll', this.scrollHandler, true);
        }

        this.handleScroll();
      }
    }
  }, {
    key: "uninstallScrollHandler",
    value: function uninstallScrollHandler() {
      if (this.state.transparent) {
        this.setState({
          transparent: false
        });
      }

      if (this.scrollHandler) {
        if (__CLIENT__) {
          window.removeEventListener('scroll', this.scrollHandler, true);
        }

        this.scrollHandler = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isDark = _this$props.isDark,
          isMobile = _this$props.isMobile,
          showHamburger = _this$props.showHamburger,
          dropdownOpen = _this$props.dropdownOpen,
          onDropdownStateToggled = _this$props.onDropdownStateToggled,
          isTransparentWhenAtScrollTop = _this$props.isTransparentWhenAtScrollTop;
      var transparent = this.state.transparent;
      var dropdownOpenOnMobile = dropdownOpen && isMobile;
      return React.createElement("header", {
        className: classNames('header', {
          'header--can-be-transparent': isTransparentWhenAtScrollTop && !dropdownOpenOnMobile,
          'header--transparent': transparent && !dropdownOpenOnMobile,
          'header--dark': isDark
        })
      }, React.createElement("h1", {
        className: "header__logo"
      }, React.createElement("a", {
        href: "/"
      }, "ClassPass")), children, showHamburger && React.createElement(Hamburger, {
        open: dropdownOpen,
        onClick: onDropdownStateToggled,
        className: "lg-hidden"
      }));
    }
  }]);

  return Header;
}(Component);
Header.propTypes = {
  onDropdownStateToggled: PropTypes.func,
  isDark: PropTypes.bool,
  isTransparentWhenAtScrollTop: PropTypes.bool,
  showHamburger: PropTypes.bool,
  isMobile: PropTypes.bool,
  dropdownOpen: PropTypes.bool,
  children: PropTypes.node
};